import { Fetch } from 'barnyard/utils/';

export const zipcodeLookup = (zipCode, onSuccess, onFailure = () => {}) => Fetch({
  url: `/api/accounts/location/${zipCode}/`,
  success: onSuccess,
  failure: onFailure
});
